const allowImg = ['jpg', 'jpeg', 'gif', 'png', 'bmp']

export default allowImg
